var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanStatement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1389 4.6665L5.19447 4.6665",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1389 7.3335L5.19447 7.3335",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 10L5.19428 10",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9165 1.3335H4.4165C3.31193 1.3335 2.4165 2.22892 2.4165 3.33349V11.8596C2.4165 13.2339 3.77079 14.1988 5.06979 13.7499L5.15497 13.7204C5.62698 13.5573 6.14295 13.5767 6.60141 13.7747L7.87335 14.3242C8.37951 14.5428 8.9535 14.5428 9.45966 14.3242L10.7316 13.7747C11.1901 13.5767 11.706 13.5573 12.178 13.7204L12.2632 13.7499C13.5622 14.1988 14.9165 13.2339 14.9165 11.8596V3.3335C14.9165 2.22893 14.0211 1.3335 12.9165 1.3335Z",
    stroke: "#333333",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanStatement);
export default __webpack_public_path__ + "static/media/loan-statement.7416d264cc7e44de52f73d5052bb76c8.svg";
export { ForwardRef as ReactComponent };